export default {
  TRANSFER: 1,          // przelew
  CASH: 2,              // gotówka
  CARD: 3,              // karta
  BARTER: 4,            // barter
  CASH_ON_DELIVERY: 5,  // za pobraniem
  PREPAYMENT: 6,        // przedpłata
  COMPENSATION: 7,      // kompensata
  OTHER: 8,             // inny
  BANK_CREDIT: 9,       // kredyt bankowy
};
